import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import bannerAvatars from '../../../resources/images/subscription/bannerAvatars.png';
import { getPurchasesBannerData } from '../../../store/slices/catalogSlice';
import { getTrialPlan } from '../../../store/slices/paymentsSlice';
import PaymentButton, { paymentBtnType } from '../PaymentButton';
import styles from './styles.module.scss';

const SubscriptionBanner = ({ inlineStyle = {} }) => {
    const { t } = useTranslation();
    const { title } = useSelector(getPurchasesBannerData);
    const trialDays = useSelector(getTrialPlan)?.period?.days;

    return (
        <div className={styles.wrapper} style={inlineStyle}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.inner}>
                <div className={styles.column}>
                    <p className={styles.price}>{t('pages.payment.title6')}</p>
                    <PaymentButton
                        text={t('buttons.freeTrial', { trialDays })}
                        type={paymentBtnType.trial}
                        extraClasses={[styles.btn]}
                        abTesting={true}
                        googleEvent={'profile'}
                    />
                </div>
                <div className={styles.icons}>
                    <img src={bannerAvatars} alt={t('pages.payment.bannerAlt')} />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionBanner;
